'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useZoomControlsContext } from './zoom-controls.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ZoomControlsOut = renderWithRef('ZoomControlsOut', null, (o, i)=>{
    useDeprecatedProps('ZoomControlsOut', o, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: 'Use `accessibleText` instead'
        }
    ]);
    let { visuallyHiddenLabel: l, accessibleText: u, children: a } = o, b = _object_without_properties(o, [
        "visuallyHiddenLabel",
        "accessibleText",
        "children"
    ]), { id: f } = useZoomControlsContext();
    return jsxs(RenderComp, {
        root: "button",
        forwardedRef: i,
        classNames: [
            'swan-zoom-controls-out'
        ],
        props: _object_spread_props(_object_spread({}, b), {
            'aria-controls': f
        }),
        children: [
            jsx(VisuallyHidden, {
                children: null != u ? u : l
            }),
            jsx(Icon, {
                iconType: "zoomOut"
            }),
            a
        ]
    });
});

export { ZoomControlsOut };
